//stores
import * as ContractsStore from '../../../../redux/middleware/ContractMiddleware';
import * as ContractStageStore from '../../../../redux/middleware/ContractStageMiddleware';
import * as ContractConcept from '../../../../redux/middleware/ContractConceptMiddleware';
import * as ContractAddendumStore from '../../../../redux/middleware/ContractAddendum.Middleware';
import * as ContractConceptScheduleStore from '../../../../redux/middleware/ContractConceptPaymentScheduleMiddleware';
import * as ContractBranchStore from '../../../../redux/middleware/ContractBranchsMiddleware';

// models
import { AppState } from '../../../../redux/reducers';
import { Contract } from '../../../../models/Entities/Contracts/Contract';
import { ContractStage } from '../../../../models/Entities/Contracts/ContractStage';
import { ContractBranch } from '../../../../models/Entities/Contracts/ContractBranch';
import { ContractConceptPaymentSchedule } from '../../../../models/Entities/Contracts/ContractConceptPaymentSchedule';
import { ErrorType } from '../../../../models/HttpError';

//#region Props

interface IProps {
    ContractId: number;
    ContractAddendumId: number;
    ContractConceptId? : number | undefined;
    ShowInputValues: boolean;
    ConceptSaved: boolean;
    // --------
    applyToRemoteExecution: boolean;
    applyToInFaceExecution: boolean;
    applyToPhoneExecution: boolean;
    applyToFailvisitExecution: boolean;
    applyToFollowUpExecution: boolean;
    // -------
    currency: string;
    OnAllSaved: (ready: boolean) => void;
}

interface ConnectedProps {
  Contract: Contract | undefined;
  Stages: ContractStage[];
  Branches: ContractBranch[];
  PaymentSchedules: ContractConceptPaymentSchedule[];

  // save status: the payment schedule store tracks these globally, not per stage
  FailOnSaving: boolean;
  FailOnUpdating: boolean;
  FailOnDeleting: boolean;
  errorOnSaving: ErrorType | undefined;
}

interface MedicalServicesDispatchProps {
    GetContractById: typeof ContractsStore.actionCreators.GetContractById;
    GetContractAddendumById: typeof ContractAddendumStore.actionCreators.GetContractAddendumById;
    GetContractConceptById: typeof ContractConcept.actionCreators.GetContractConceptById;
    GetAllContractStagesByAddendumId: typeof ContractStageStore.actionCreators.GetAllContractStagesByAddendumId;
    GetContractBranchsByAddendumId: typeof ContractBranchStore.actionCreators.GetContractBranchsByAddendumId;
    GetAllContractsConceptPaymentSchedule: typeof ContractConceptScheduleStore.actionCreators.GetAllContractsConceptPaymentSchedule;
    AddContractConceptPaymenSchedule: typeof ContractConceptScheduleStore.actionCreators.AddContractConceptPaymenSchedule;
    UpdateContractConceptPaymentSchedule: typeof ContractConceptScheduleStore.actionCreators.UpdateContractConceptPaymentSchedule;
    DeleteContractConceptPaymentSchedule: typeof ContractConceptScheduleStore.actionCreators.DeleteContractConceptPaymentSchedule;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const CurrentContract = state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId ) || undefined;
    const CurrentAddendum = CurrentContract?.addendums?.find((item: any) => item.id === ownProps.ContractAddendumId) || undefined;
    const CurrentConcept = CurrentAddendum?.concepts?.find((item: any) => item.id === ownProps.ContractConceptId) || undefined;
    const CurrentStages = CurrentAddendum?.stages || undefined;
    const CurrentConceptPaymentSchedules = CurrentConcept?.paymentSchedule;

    // branches are loaded per-addendum, with the contract and the global ContractBranch store as fallbacks
    const branchesFromAddendum = CurrentAddendum?.branches || [];
    const branchesFromContract = CurrentContract?.branches || [];
    const branchesFromStore = state.ContractBranch?.list || [];
    let AvailableBranches: ContractBranch[] = branchesFromStore;
    if (branchesFromContract.length > 0) {
        AvailableBranches = branchesFromContract;
    }
    if (branchesFromAddendum.length > 0) {
        AvailableBranches = branchesFromAddendum;
    }
    const UniqueBranches = AvailableBranches.filter((branch: ContractBranch, index: number, all: ContractBranch[]) =>
        all.findIndex((candidate: ContractBranch) => candidate.id === branch.id) === index
    );

    return {
        Contract: CurrentContract,
        Stages: CurrentStages,
        Branches: UniqueBranches,
        PaymentSchedules: CurrentConceptPaymentSchedules,

        // save status
        FailOnSaving: state.ContractConceptPaymentSchedule?.failOnAddingNewOne ?? false,
        FailOnUpdating: state.ContractConceptPaymentSchedule?.failOnUpdatingOne ?? false,
        FailOnDeleting: state.ContractConceptPaymentSchedule?.failOnDeletingOne ?? false,
        errorOnSaving: state.ContractConceptPaymentSchedule?.error || undefined
    }
};

export const mapDispatchToProps = {
    ...ContractsStore.actionCreators,
    ...ContractAddendumStore.actionCreators,
    ...ContractStageStore.actionCreators,
    ...ContractConcept.actionCreators,
    ...ContractConceptScheduleStore.actionCreators,
    ...ContractBranchStore.actionCreators
};

//#endregion Props
